import React from 'react';
import { StatusTip } from 'tea-component';

import './index.scss';

export default function StatusLoading(props: any) {
  const { children, ...restProps } = props;
  return (
    <div className="db-loading-wraps">
      <div className="db-loading">
        <StatusTip {...restProps} />
      </div>
      {children}
    </div>
  );
}
